module.exports = __webpack_public_path__ + "img/Hillel_Gershuni.72848966.png";